import type { LucideLikeIcon } from '@givmo/design-system';
import type { ModuleNav } from '@givmo/org-console';
import { BookOpenText, FileDown, LayoutList, Scale, Table2 } from 'lucide-react';
import {
  BOOKS_EXPORT_PERMISSION,
  BOOKS_READ_PERMISSION,
  BOOKS_ROUTES,
  BOOKS_SLUG,
} from './books-routes';

/**
 * Books' rows (D-BM-17 (1)): Overview · Statements · Ledger · Reconciliation · Export. One section,
 * so the shell draws no caption; the shell supplies Team, the frame and the Organization section.
 * The root row keeps the id `books` (the `menu-books` testid). Every row needs `books:read` except
 * Export, which needs the act's own string, so a Member sees no Export row rather than a greyed one.
 */
export const BOOKS_NAV: ModuleNav<LucideLikeIcon> = {
  slug: BOOKS_SLUG,
  sections: [
    {
      id: BOOKS_SLUG,
      label: 'Books',
      rows: [
        {
          id: BOOKS_SLUG,
          label: 'Overview',
          icon: LayoutList,
          destination: { kind: 'module', slug: BOOKS_SLUG },
          requires: BOOKS_READ_PERMISSION,
        },
        {
          id: 'books-statements',
          label: 'Statements',
          icon: BookOpenText,
          destination: { kind: 'page', path: BOOKS_ROUTES.statements },
          requires: BOOKS_READ_PERMISSION,
        },
        {
          id: 'books-ledger',
          label: 'Ledger',
          icon: Table2,
          destination: { kind: 'page', path: BOOKS_ROUTES.ledger },
          requires: BOOKS_READ_PERMISSION,
        },
        {
          id: 'books-reconciliation',
          label: 'Reconciliation',
          icon: Scale,
          destination: { kind: 'page', path: BOOKS_ROUTES.reconciliation },
          requires: BOOKS_READ_PERMISSION,
        },
        {
          id: 'books-export',
          label: 'Export',
          icon: FileDown,
          destination: { kind: 'page', path: BOOKS_ROUTES.export },
          requires: BOOKS_EXPORT_PERMISSION,
        },
      ],
    },
  ],
  includeOrganizationSection: true,
};
